//
//
//
//
//
//
//
//
//
//
//

import CommentItem from "./CommentItem.vue";

export default {
  name: "CommentList",
  componentName: "CommentList",
  components: {
    CommentItem,
  },
  props: {
    comments: {
      type: Array,
      default: () => [],
    },
    postid: {
      type: String,
      default: "",
    },
  },
};
